import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ObjetoSomaEntity } from 'src/app/services/servicio-soma.service';

@Component({
  selector: 'app-body-soma',
  templateUrl: './body-soma.component.html',
  styleUrls: ['./body-soma.component.css']
})
export class BodySomaComponent implements OnInit, OnChanges {

  @Input() public arrayObjetoSoma : ObjetoSomaEntity[] = [];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getArrayObjetoSoma();
  }

  private async getArrayObjetoSoma() {
    try {
      await this.arrayObjetoSoma;
    }catch(exception){
      console.log(exception);
    }
  }

}
